export class Deferred<T> {
  public promise: Promise<T>;

  private state: 'pending' | 'fulfilled' | 'rejected' = 'pending';

  private _promiseResolve: Function;
  private _promiseReject: Function;

  constructor() {
    this.promise = new Promise((resolve, reject) => {
      this._promiseResolve = resolve;
      this._promiseReject = reject;
    });

    this.promise.then(
      () => this.state = 'fulfilled',
      () => this.state = 'rejected'
    );
  }

  resolve(value?: any) {
    if (this.isPending()) {
      this._promiseResolve(value);
    } else {
      throw new Error('Deferred cannot be resolved twice');
    }
  }

  reject(reason?: any) {
    if (this.isPending()) {
      this._promiseReject(reason);
    } else {
      throw new Error('Deferred cannot be resolved twice');
    }
  }

  isResolved() {
    return this.state !== 'pending';
  }

  isPending() {
    return this.state === 'pending';
  }

  isFulfilled() {
    return this.state === 'fulfilled';
  }

  isRejected() {
    return this.state === 'rejected';
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/deferred.ts